/* import __COLOCATED_TEMPLATE__ from './money-per-unit-field-input-market.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import { bool, not } from '@ember/object/computed';
import { action, computed, set } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { scheduleOnce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import { measureTextWidth } from '@square/dashboard-utilities/utils/input';
import MarketInputCurrency from '@dashboard/shared-ui/components/market-input-currency';
const FOCUS_OUT_PADDING = 22;
const FOCUS_IN_PADDING = 30;
let MoneyPerUnitFieldInputMarket = (_dec = service('formatter'), _dec2 = bool('unitAbbreviation'), _dec3 = computed('hasAbbreviation', 'isEditing', 'value.amount'), _dec4 = computed(), _dec5 = computed('unitAbbreviation'), _dec6 = computed('currencyCode', 'formatterService', 'placeholderOverride', 'unitAbbreviation', 'unitAbbreviationLabel'), _class = class MoneyPerUnitFieldInputMarket extends MarketInputCurrency {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "formatterService", _descriptor, this);
    _defineProperty(this, "classNameBindings", ['noAbbreviation:money-per-unit-field-input--no-abbreviation', 'alignRight:money-per-unit-field-input--align-right']);
    // passed in
    _defineProperty(this, "inputClassNames", null);
    _defineProperty(this, "unitAbbreviation", null);
    _defineProperty(this, "value", null);
    _defineProperty(this, "label", null);
    _defineProperty(this, "keyUp", null);
    _defineProperty(this, "onChange", null);
    _defineProperty(this, "alignRight", false);
    _defineProperty(this, "placeholderOverride", '');
    // internal
    _defineProperty(this, "isEditing", false);
    _initializerDefineProperty(this, "hasAbbreviation", _descriptor2, this);
  }
  onTextDidChange() {}
  onFocusIn() {}
  onFocusOut() {}
  get showAbbreviation() {
    return this.hasAbbreviation && (this.isEditing || !isEmpty(this.value?.amount));
  }
  get noAbbreviation() {
    return not('showAbbreviation');
  }
  get unitAbbreviationLabel() {
    return `/${this.unitAbbreviation}`;
  }
  get placeholder() {
    if (!isEmpty(this.placeholderOverride)) {
      return this.placeholderOverride;
    } else {
      return isEmpty(this.unitAbbreviation) ? this.formatterService.currency(0, this.currencyCode) : `${this.formatterService.currency(0, this.currencyCode)}${this.unitAbbreviationLabel}`;
    }
  }
  set placeholder(value) {
    set(this, 'placeholderOverride', value);
  }
  didInsert() {
    this.setInputWidth();
  }
  onMoneyValueChangeAction(newValue) {
    set(this, 'isEditing', false);
    this.onMoneyValueChange?.(newValue);
    this.onChange?.(newValue);
  }
  didUpdateAttrs() {
    super.didUpdateAttrs();
    scheduleOnce('afterRender', this, this.setInputWidth);
  }
  onFocus() {
    this.setInputWidth(FOCUS_IN_PADDING);
    if (this.onFocusIn) {
      this.onFocusIn();
    }
  }
  onBlur() {
    set(this, 'isEditing', false);
    this.setInputWidth();
    if (this.onFocusOut) {
      this.onFocusOut();
    }
  }
  onTextDidChangeAction(newVal) {
    set(this, 'isEditing', true);
    this.onTextDidChange(newVal);
    scheduleOnce('afterRender', this, this.setInputWidth, FOCUS_IN_PADDING, newVal);
  }
  setInputWidth(padding = FOCUS_OUT_PADDING, inputVal = this.valueToShow(this.value)) {
    if (!this.alignRight && this.element) {
      const textWidth = measureTextWidth(inputVal);
      const abbreviationElement = this.element.querySelectorAll('.money-per-unit-field-input-market__unit-abbreviation')[0];
      const inputElement = this.element.querySelectorAll('.money-per-unit-field-input-market__input')[0].shadowRoot.querySelectorAll('input')[0];
      if (!abbreviationElement || !inputElement) {
        return;
      }
      abbreviationElement.style.left = `${textWidth + padding}px`;
      // This jank is required to properly cover the placeholder text when no input is there but the
      // unit abbreviation is present
      const SINGLE_CHARACTER_WIDTH = 8;
      inputElement.style.width = this.showAbbreviation ? textWidth === 0 ? `${SINGLE_CHARACTER_WIDTH}px` : `${textWidth + padding}px` : '';
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "formatterService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "hasAbbreviation", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "showAbbreviation", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "showAbbreviation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "noAbbreviation", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "noAbbreviation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unitAbbreviationLabel", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "unitAbbreviationLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "placeholder", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "placeholder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "didInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onMoneyValueChangeAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onMoneyValueChangeAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onFocus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBlur", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBlur"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTextDidChangeAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTextDidChangeAction"), _class.prototype), _class);
export { MoneyPerUnitFieldInputMarket as default };